import { useCallback, useContext, useEffect } from "react";
import { convertFromRaw, EditorState } from "draft-js";

import Grid from "@material-ui/core/Grid";

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer } from "./styles/Produto";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import Btn from "../../../components/buttons/Btn";
import {
  ProdutoContext,
  ProdutoContextProvider,
} from "./contexts/ProdutoContext";
import { findParceirosComerciais } from "../../../repositories/qerpapi/erp/prouser/v1/ParceirosComerciais";
import AccordionProdutoPrincipal from "./children/AccordionProdutoPrincipal";
import AccordionProdutoFornecedor from "./children/AccordionProdutoFornecedor";
import AccordionProdutoLocalEstoque from "./children/AccordionProdutoLocalEstoque";
import AccordionProdutoRelacionado from "./children/AccordionProdutoRelacionado";
import AccordionProdutoIntegraccao from "./children/AccordionProdutoIntegraccao";
import AccordionProdutoFichaTecnicaComercial from "./children/AccordionProdutoFichaTecnicaComercial";
import { findDepartamento } from "../../../repositories/qerpapi/erp/estoque/v1/DepartamentoRepository";
import { findSetor } from "../../../repositories/qerpapi/erp/estoque/v1/SetorRepository";
import useProdutoController from "./controllers/ProdutoController";
import { findGrupoEstoque } from "../../../repositories/qerpapi/erp/estoque/v1/GrupoEstoqueRepository";
import { findLocaisEstoques } from "../../../repositories/qerpapi/erp/estoque/v1/LocalEstoqueRepository";
import { findFabricantes } from "../../../repositories/qerpapi/erp/estoque/v1/FabricanteRepository";
import { findUnidades } from "../../../repositories/qerpapi/erp/estoque/v1/UnidadeRepository";
import { findNcm } from "../../../repositories/qerpapi/erp/nf/v1/NcmRepository";
import { findFornecedores } from "../../../repositories/qerpapi/erp/prouser/v1/FornecedoresRepository";
import { findTabelaPrecos } from "../../../repositories/qerpapi/erp/prouser/v1/TabelaPrecos";
import AccordionProdutoTabelaPreco from "./children/AccordionProdutoTabelaPreco";
import { findProdutos } from "../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import MaskService from "../../../utils/mask/maskService";
import isJSON from "../../../utils/isJSON";
import { downloadObjectS3 } from "../../../repositories/qerpapi/erp/aws/v1/S3Repository";

const View = ({ location }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    //Inputs
    setMainProductId,
    setMainActive,
    setMainConversionFactor,
    setTaxConversionFactor,
    setSupplierConversionFactor,
    setMainDescription,
    setMainResume,
    setMainBarCode,
    setMainIcmsEcf,
    setMainNcm,
    setMainCest,
    setMainGtin,
    setMainTaxGtin,
    setMainCodeAnp,
    setMainStockUnit,
    setMainManufacturer,
    setMainType,
    mainGroup,
    setMainGroup,
    setMainSubgroup,
    setMainSalesUnit,
    setMainTaxUnit,
    setMainDeliveryUnit,
    setSupplier,
    setDatasheetWidth,
    setDatasheetWeight,
    setDatasheetCubage,
    setDatasheetHeight,
    setDatasheetLength,
    setDatasheetAnvisa,
    setMainPhotos,
    setSupplierDescription,
    setSupplierPurchaseUnit,
    setBarCodeAdditional,
    setStockLocations,
    setSupplierOthers,
    setDataSheetTags,
    setRelatedProducts,
    setSimilarProducts,
    setTransformationProducts,
    mainProductId,
    setDatasheetQtdPackaging,
    setDatasheetObservation,
    setWoocomerceShowSite,
    setMainUseBalance,
    setFixedPrice,
    setDatasheetGeneric,
    setLunetNegativeStock,
    setWoocomerceUpdateSite,
    setDatasheetBlockNf,
    setDatasheetBlockCf,
    setDatasheetPublishedPrice,
    setDatasheetTrackPrice,
    setDatasheetLastSale,
    setDatasheetLastPurchase,
    setDatasheetLastBudget,
    setDatasheetDepth,
    setDatasheetDescriptionANP,
    setDatasheetGlpPetroleum,
    setDatasheetNationalGas,
    setDatasheetImportedGas,
    setDatasheetStartingValueWithoutICMS,

    //List
    listSupplier,
    setListSupplier,
    setListNcm,
    listUnits,
    setListUnits,
    listManufacturer,
    setListManufacturer,
    setListStockLocations,
    listGroups,
    setListGroups,
    listSubgroups,
    setListSubgroups,
    setListDepartments,
    setListSectors,
    setListCommercialPartner,
    setExpanded,
    setLoadingInputs,
    loading,
    setLoading,
    setPricesList,
    setPriceTable,
    setProductBackup,
    productBackup,
    setSupplierRef,

    // preços e custos
    setMainSalePrice,
    setMainTaxPrice,
    setMainGrossCost,
    setMainFreightValue,
    setMainFreightPercentage,
    setMainWholesaleValue,
    setMainInsuranceValue,
    setMainInsurancePercentage,
    setMainDiscountValue,
    setMainDiscountPercentage,
    setMainOthersValue,
    setMainOthersPercentage,
    setMainIcmsStValue,
    setMainIcmsStPercentage,
    setMainIpiValue,
    setMainIpiPercentage,
    setMainPisValue,
    setMainPisPercentage,
    setMainCofinsValue,
    setMainCofinsPercentage,
    setMainSalesMargin,
    setDataEditor,
  } = useContext(ProdutoContext);
  const { handleSubmit, clearAll, handleBackSubmit } = useProdutoController();

  useEffect(() => {
    setExpanded({ main: true });
  }, [setExpanded]);

  useEffect(() => {
    async function getData() {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listSupplier: true,
          listNcm: true,
          listManufacturer: true,
          listUnits: true,
          listCommercialPartner: true,
          listStockLocations: true,
          pricesList: true,
          listDepartments: true,
          listSectors: true,
        }));

        const [
          resultSupplier,
          resultNcm,
          resultManufacturer,
          resultUnits,
          resultCommercialPartner,
          resultStockLocations,
          resultPrices,
          resultDepartments,
          resultSectors,
        ] = await Promise.all([
          findFornecedores(queryParams.empresa_cnpj),
          findNcm(queryParams.empresa_cnpj),
          findFabricantes(queryParams.empresa_cnpj),
          findUnidades(queryParams.empresa_cnpj),
          findParceirosComerciais({
            empresa_cnpj: queryParams.empresa_cnpj,
          }),
          findLocaisEstoques(queryParams.empresa_cnpj),
          findTabelaPrecos(queryParams.empresa_cnpj),
          findDepartamento({
            empresa_cnpj: queryParams.empresa_cnpj,
          }),
          findSetor({
            empresa_cnpj: queryParams.empresa_cnpj,
          }),
        ]);

        if (resultSupplier.success)
          setListSupplier(
            resultSupplier.data
              .filter((el) => el.ativo === "S")
              .sort((current, next) => current.id - next.id)
          );

        if (resultNcm.success) setListNcm(resultNcm.data);

        if (resultManufacturer.success)
          setListManufacturer(
            resultManufacturer.data.sort((a, b) =>
              a.descricao.localeCompare(b.descricao)
            )
          );

        if (resultUnits.success) setListUnits(resultUnits.data);

        if (resultCommercialPartner.success)
          setListCommercialPartner(resultCommercialPartner.data);

        if (resultStockLocations.success)
          setListStockLocations(
            resultStockLocations.data.filter((el) => el.ativo !== "N") ?? []
          );

        if (resultPrices.success) setPricesList(resultPrices.data);

        if (resultDepartments.success)
          setListDepartments(resultDepartments.data);

        if (resultSectors.success) setListSectors(resultSectors.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listSupplier: false,
          listNcm: false,
          listManufacturer: false,
          listUnits: false,
          listCommercialPartner: false,
          listStockLocations: false,
          pricesList: false,
          listDepartments: false,
          listSectors: false,
        }));
      }
    }

    getData();
  }, [
    queryParams.empresa_cnpj,
    setListCommercialPartner,
    setListDepartments,
    setListManufacturer,
    setListNcm,
    setListSectors,
    setListStockLocations,
    setListSupplier,
    setListUnits,
    setLoadingInputs,
    setPricesList,
  ]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listGroups: true,
        }));

        const resultGroups = await findGrupoEstoque({
          empresa_cnpj: queryParams.empresa_cnpj,
          include: "subgrupos",
          where: { ativo: 1 },
        });

        if (resultGroups.success)
          setListGroups(
            resultGroups.data.sort((a, b) =>
              a.descricao.localeCompare(b.descricao)
            )
          );
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listGroups: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListGroups, setLoadingInputs]);

  useEffect(() => {
    if (!location?.state?.item?.id) {
      clearAll();
      return;
    }

    setMainProductId(
      location?.state?.item?.cloned ? null : location.state.item.id
    );

    async function getProductData() {
      try {
        setLoading(true);

        const dataCustomer = await findProdutos({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: location.state.item.id,
          include:
            "produtosfotos,produtostags,estoques.localestoque,tabelasprecosprodutos,codigosbarrasalternativos,fornecedoresprodutos,produtosrelacionados,produtossimilares,produtostransformacoes,ncm.ncmcest",
        });

        if (!dataCustomer.success && !dataCustomer.data) return;

        const { data } = dataCustomer;

        //Principal
        setProductBackup(data);
        setMainConversionFactor(
          data?.fator_conversao_venda
            ? MaskService.changeUStoBR(data?.fator_conversao_venda)
            : "1,00000"
        );
        setSupplierConversionFactor(
          data?.fator_conversao
            ? MaskService.changeUStoBR(data?.fator_conversao)
            : "1,00000"
        );
        setTaxConversionFactor(
          data?.fator_conversao_tributavel
            ? MaskService.changeUStoBR(data?.fator_conversao_tributavel)
            : "1,00000"
        );

        setMainActive(data.produtoativo === "SIM");
        setMainDescription(data.descricao ? data.descricao : "");
        setMainResume(data.descricaoresumida ? data.descricaoresumida : "");
        setMainBarCode(
          data.codigobarras && !location?.state?.item?.cloned
            ? data.codigobarras
            : ""
        );
        setMainUseBalance(data.utilizarcodigobalanca === "S");
        setMainIcmsEcf(data.icms ? data.icms.replace(".", "") : "");
        setMainNcm(data.ncm ? { ncm: data.ncm.ncm } : null);
        setMainCest(data.cest ? { cest: data.cest } : null);
        setMainGtin(data.gtin ? parseInt(data.gtin) : "");
        setMainTaxGtin(
          data.gtin_tributavel ? parseInt(data.gtin_tributavel) : ""
        );
        setMainType(
          [
            {
              label: "Revenda",
              id: "R",
            },
            {
              label: "Uso/Consumo Próprio",
              id: "U",
            },
            {
              label: "Insumo",
              id: "I",
            },
            {
              label: "Ativo",
              id: "A",
            },
            {
              label: "Outros",
              id: "O",
            },
          ].find((type) => type.id === data.tipo) || null
        );

        const getFixedParseFloat = (value, fractionDigits) => {
          return (!isNaN(parseFloat(value)) ? parseFloat(value) : 0).toFixed(
            fractionDigits
          );
        };

        setMainGrossCost(
          MaskService.toMask(
            "decimal",
            getFixedParseFloat(data?.custobruto, 5),
            5
          )
        );

        if (queryParams.paramprecoestoqueunico === "SIM") {
          setMainFreightValue(
            MaskService.toMask("decimal", getFixedParseFloat(data?.frete, 5), 5)
          );

          setMainFreightPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.frete_porc, 5),
              5
            )
          );

          setMainWholesaleValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.precoatacado, 2),
              2
            )
          );

          setMainInsuranceValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.seguro, 5),
              5
            )
          );

          setMainInsurancePercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.seguro_porc, 5),
              5
            )
          );

          setMainDiscountValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.desconto, 5),
              5
            )
          );

          setMainDiscountPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.desconto_porc, 5),
              5
            )
          );

          setMainOthersValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.outrasdesp, 5),
              5
            )
          );

          setMainOthersPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.outrasdesp_porc, 5),
              5
            )
          );

          setMainIcmsStValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.icmsst, 5),
              5
            )
          );

          setMainIcmsStPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.icmsst_porc, 5),
              5
            )
          );

          setMainIpiValue(
            MaskService.toMask("decimal", getFixedParseFloat(data?.ipi, 5), 5)
          );

          setMainIpiPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.ipi_porc, 5),
              5
            )
          );

          setMainPisValue(
            MaskService.toMask("decimal", getFixedParseFloat(data?.pis, 5), 5)
          );

          setMainPisPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.pis_porc, 5),
              5
            )
          );

          setMainCofinsValue(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.cofins, 5),
              5
            )
          );

          setMainCofinsPercentage(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.cofins_porc, 5),
              5
            )
          );

          setMainSalePrice(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.precovenda, 2),
              2
            )
          );

          setMainTaxPrice(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.valor_tributavel, 2),
              2
            )
          );

          setMainSalesMargin(
            MaskService.toMask(
              "decimal",
              getFixedParseFloat(data?.porcfixo, 2),
              2
            )
          );
        }

        setFixedPrice(data.precofixo === "SIM");

        // aqui eu pego os codigos que nao tem idestoque e seto em "barCodeAdditional"
        let alternativeBarCodes =
          data?.codigosbarrasalternativos
            ?.filter((barCode) => !barCode.idestoque)
            .map((code) => {
              return {
                codigobarras: code.codigobarras ?? null,
                qtdvenda: code.qtdvenda ?? null,
                percentual_desconto: code.percentual_desconto ?? null,
                unidade_medida: code.unidade_medida ?? null,
                idestoque: code.idestoque ?? null,
              };
            }) ?? [];

        setBarCodeAdditional(alternativeBarCodes);

        //Local de estoque
        if (!data.estoques) {
          setStockLocations([]);
        } else {
          let estoqueBody = data.estoques.map((estoque) => {
            let barCodes = data?.codigosbarrasalternativos?.filter(
              (code) => code.idestoque === estoque.id
            );

            estoque = {
              ...estoque,
              descricao: estoque.localestoque?.descricao || "",
              codigosbarrasalternativos: barCodes,
              inativo: estoque?.inativo ? estoque.inativo : "N",
              codigobarras: estoque?.codigobarras ? estoque.codigobarras : "",
            };

            if (
              !estoque.codigosbarrasalternativos.length ||
              location?.state?.item?.cloned
            )
              delete estoque.codigosbarrasalternativos;

            if (location?.state?.item?.cloned) estoque.codigobarras = "";

            if (location?.state?.item?.acceptResetStockLocation) {
              estoque = {
                idlocalestoque: estoque.idlocalestoque,
                idproduto: estoque.idproduto,
                descricao: estoque.descricao,
                inativo: estoque?.inativo ? estoque.inativo : "S",
                codigobarras: estoque?.codigobarras ? estoque.codigobarras : "",
              };
            }

            return estoque;
          });

          setStockLocations(estoqueBody);
        }

        // Tabela de preços
        if (data.tabelasprecosprodutos) {
          const tablePrices = data.tabelasprecosprodutos.map((table) => {
            if (table.pivot) {
              return {
                customValues: true,
                id: table.id,
                descricao: table.descricao,
                margem: MaskService.toMask(
                  "decimal",
                  table.pivot.margem
                    ? parseFloat(table.pivot.margem).toFixed(2)
                    : "0.00"
                ),
                descontopadrao: table.pivot.descontopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.pivot.descontopadrao).toFixed(2)
                    )
                  : "0.00",
                descontomaximopadrao: table.pivot.descontomaximopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.pivot.descontomaximopadrao).toFixed(2)
                    )
                  : "0.00",
                comissaopadrao: table.pivot.comissaopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.pivot.comissaopadrao).toFixed(2)
                    )
                  : "0.00",
                ativo: table.ativo === "S" ? "S" : "N",
              };
            } else {
              return {
                id: table.id,
                descricao: table.descricao,
                margem: table.porcmargemvenda
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.porcmargemvenda)
                    )
                  : "-- ",
                descontopadrao: table.descontopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.descontopadrao).toFixed(2)
                    )
                  : "0.00",
                descontomaximopadrao: table.descontomaximopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.descontomaximopadrao).toFixed(2)
                    )
                  : "0.00",
                comissaopadrao: table.comissaopadrao
                  ? MaskService.toMask(
                      "decimal",
                      parseFloat(table.comissaopadrao).toFixed(2)
                    )
                  : "0.00",
                ativo: table.ativo === "S" ? "S" : "N",
              };
            }
          });
          setPriceTable(tablePrices);
        } else setPriceTable([]);

        //Fornecedor
        setSupplierDescription(data?.descricaofornecedor ?? "");
        setSupplierRef(data?.codigoprodutonofornecedor ?? "");

        //Outros Fornecedores
        let newOtherSuppliers = data.fornecedoresprodutos.map((sup) => {
          return {
            idfornecedor: sup.id,
            refforn: sup.pivot?.refforn ?? "",
            unidade_compra: sup.pivot?.unidade_compra ?? "",
            fator_conversao: sup.pivot?.fator_conversao ?? "",
            descricaofornecedor: sup.pivot?.descricaofornecedor ?? "",
          };
        });

        setSupplierOthers(newOtherSuppliers ?? []);

        // Ficha técnica/Comercial
        setDatasheetWeight(
          MaskService.toMask(
            "decimal",
            data?.peso ? parseFloat(data?.peso).toFixed(3) : "0.000",
            3
          )
        );
        setDatasheetCubage(
          MaskService.toMask(
            "decimal",
            data?.cubagem ? parseFloat(data?.cubagem).toFixed(3) : "0.000",
            3
          )
        );
        setDatasheetQtdPackaging(
          MaskService.toMask(
            "decimal",
            data?.qtdpacote ? parseFloat(data?.qtdpacote).toFixed(2) : "0.00",
            2
          )
        );
        setDatasheetWidth(
          MaskService.toMask(
            "decimal",
            data?.largura ? parseFloat(data?.largura).toFixed(3) : "0.000",
            3
          )
        );
        setDatasheetHeight(
          MaskService.toMask(
            "decimal",
            data?.altura ? parseFloat(data?.altura).toFixed(3) : "0.000",
            3
          )
        );
        setDatasheetLength(
          MaskService.toMask(
            "decimal",
            data?.comprimento
              ? parseFloat(data?.comprimento).toFixed(3)
              : "0.000",
            3
          )
        );
        setDatasheetDepth(
          MaskService.toMask(
            "decimal",
            data?.profundidade
              ? parseFloat(data?.profundidade).toFixed(3)
              : "0.000",
            3
          )
        );
        setDatasheetAnvisa(data.registroanvisa ?? "");
        setMainCodeAnp(data.cod_anp ? data.cod_anp : "");
        setDatasheetObservation(data?.observacao ?? "");
        setDatasheetGeneric(data.produtogenerico === "S");

        //Combustivel
        setDatasheetDescriptionANP(data.desc_anp); //verificar quando for autopreenchido pelo cod_anp ou posto manualmente
        setDatasheetGlpPetroleum(
          MaskService.toMask(
            "decimal",
            parseFloat(data.perc_glp_derivado_petroleo).toFixed(4),
            4
          )
        );
        setDatasheetNationalGas(
          MaskService.toMask(
            "decimal",
            parseFloat(data.perc_gas_natural_nacional).toFixed(4),
            4
          )
        );
        setDatasheetImportedGas(
          MaskService.toMask(
            "decimal",
            parseFloat(data.perc_gas_natural_importado).toFixed(4),
            4
          )
        );
        setDatasheetStartingValueWithoutICMS(
          MaskService.toMask(
            "decimal",
            parseFloat(data.valor_partida_sem_icms).toFixed(4),
            4
          )
        );

        let esptecContent = isJSON(data?.esptec)
          ? convertFromRaw(JSON.parse(data?.esptec))
          : false;

        setDataEditor(
          esptecContent
            ? EditorState.createWithContent(esptecContent)
            : EditorState.createEmpty()
        );

        // Especificações Comerciais
        let toLocaleDate = (date) => new Date(date).toLocaleString("pt-BR");

        setDatasheetBlockNf(data.travarnf === "1");
        setDatasheetBlockCf(data.travarcf === "1");
        setDatasheetPublishedPrice(data.jornal === 1);
        setDatasheetTrackPrice(data.acompanharpreco === 1);
        setDatasheetLastSale(
          data.dataultimavenda ? toLocaleDate(data.dataultimavenda) : null
        );
        setDatasheetLastPurchase(
          data.dataultimacompra ? toLocaleDate(data.dataultimacompra) : null
        );
        setDatasheetLastBudget(
          data.dataultimoorcamento
            ? toLocaleDate(data.dataultimoorcamento)
            : null
        );
        //Produtos Relacionados
        setRelatedProducts(
          data.produtosrelacionados ? data.produtosrelacionados : []
        );

        //Produtos Similares
        setSimilarProducts(
          data.produtossimilares ? data.produtossimilares : []
        );

        //Produtos Transformacao
        setTransformationProducts(
          data.produtostransformacoes
            ? data.produtostransformacoes.map((item) => ({
                id: item.id,
                codigobarras: item.codigobarras,
                descricao: item.descricao,
                fator: MaskService.toMask(
                  "decimal",
                  parseFloat(item.pivot?.fator_transformacao ?? 0.0).toFixed(5),
                  5
                ),
              }))
            : []
        );

        // Integração
        setWoocomerceShowSite(data.exibe_site === "S");
        setLunetNegativeStock(
          [
            { label: "Sim", id: "S" },
            { label: "Não", id: "N" },
            {
              label: "Utilizar configuração do Grupo de Estoque",
              id: "G",
            },
          ].find((e) => e.id === (data.integracao_lunet_estoque_negativo ?? ""))
        );
        setWoocomerceUpdateSite(data.produtoatualizado === "S");

        //Tags
        if (!data.produtostags) {
          setDataSheetTags([]);
        } else {
          let tagsBody = [];

          data.produtostags.forEach((tag, index) => {
            tagsBody.push(tag.tag || "");
          });
          setDataSheetTags(tagsBody);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    getProductData();
    // eslint-disable-next-line
  }, [
    clearAll,
    location,
    queryParams.empresa_cnpj,
    setMainUseBalance,
    mainProductId,
    setMainProductId,
    setMainActive,
    setMainDescription,
    setMainResume,
    setMainBarCode,
    setMainIcmsEcf,
    setMainNcm,
    setMainCest,
    setMainGtin,
    setMainTaxGtin,
    setMainCodeAnp,
    setDatasheetWidth,
    setDatasheetWeight,
    setDatasheetCubage,
    setDatasheetHeight,
    setDatasheetLength,
    setDatasheetAnvisa,
    setMainPhotos,
    setSupplierDescription,
    setBarCodeAdditional,
    setStockLocations,
    setSupplierOthers,
    setDataSheetTags,
    setRelatedProducts,
    setSimilarProducts,
    setTransformationProducts,
    queryParams.paramprecoestoqueunico,
    setDataEditor,
    setDatasheetObservation,
    setDatasheetQtdPackaging,
    setLoading,
    setMainCofinsPercentage,
    setMainCofinsValue,
    setMainDiscountPercentage,
    setMainDiscountValue,
    setMainFreightPercentage,
    setMainFreightValue,
    setMainGrossCost,
    setMainIcmsStPercentage,
    setMainIcmsStValue,
    setMainInsurancePercentage,
    setMainInsuranceValue,
    setMainIpiPercentage,
    setMainIpiValue,
    setMainOthersPercentage,
    setMainOthersValue,
    setMainPisPercentage,
    setMainPisValue,
    setMainSalePrice,
    setMainTaxPrice,
    setMainSalesMargin,
    setMainType,
    setMainWholesaleValue,
    setPriceTable,
    setProductBackup,
    setSupplierRef,
    setWoocomerceShowSite,
    setFixedPrice,
    setDatasheetGeneric,
    setLunetNegativeStock,
    setWoocomerceUpdateSite,
    setDatasheetBlockNf,
    setDatasheetBlockCf,
    setDatasheetPublishedPrice,
    setDatasheetTrackPrice,
    setDatasheetLastSale,
    setDatasheetLastPurchase,
    setDatasheetLastBudget,
    setDatasheetDepth,
    setDatasheetDescriptionANP,
    setDatasheetGlpPetroleum,
    setDatasheetNationalGas,
    setDatasheetImportedGas,
    setDatasheetStartingValueWithoutICMS,
  ]);

  useEffect(() => {
    if (!productBackup?.unidade_tributavel) {
      setMainTaxUnit(null);
      return;
    }

    setMainTaxUnit(
      listUnits.find((opt) => opt.un === productBackup.unidade_tributavel) ||
        null
    );
  }, [productBackup, listUnits, setMainTaxUnit]);

  useEffect(() => {
    if (!productBackup?.unidade) {
      setMainStockUnit(null);
      return;
    }

    setMainStockUnit(
      listUnits.find((opt) => opt.un === productBackup.unidade) || null
    );
  }, [productBackup, listUnits, setMainStockUnit]);

  useEffect(() => {
    if (!productBackup?.idfabricante) return;

    setMainManufacturer(
      listManufacturer.find(
        (opt) => opt.id === parseInt(productBackup.idfabricante)
      ) || null
    );
  }, [productBackup, listManufacturer, setMainManufacturer]);

  useEffect(() => {
    const isImage = (fileName) => {
      return (
        ["png", "jpg", "jpeg"].indexOf(
          fileName.replace(/^.*\./, "").toLowerCase()
        ) !== -1
      );
    };

    const getBase64OfFileInS3 = async (s3Key) => {
      if (!s3Key) return false;

      try {
        const response = await downloadObjectS3({
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          body: {
            bucket: "qerp-public",
            key: s3Key,
          },
        });

        if (!response?.data?.archive_base64) return false;

        return response.data.archive_base64;
      } catch (e) {
        console.error(e);
      }
    };

    async function handlerMainPhotos() {
      if (!productBackup?.produtosfotos) return;

      let photoBody = [];
      for (let photo of productBackup.produtosfotos) {
        if (photo.id && !photo.imagebase64 && isImage(photo.arquivo)) {
          const newImageBase64 = await getBase64OfFileInS3(photo.s3_key);
          if (newImageBase64) photo.imagebase64 = newImageBase64;
        }

        photoBody.push({
          id: photo.id,
          error: false,
          name: photo.arquivo,
          file: photo.imagebase64,
          preview: "data:image/png;base64," + photo.imagebase64,
          uploaded: false,
          checkMain: photo.principal === "S" ? true : false,
          lastModifiedDate: photo.update_at,
          s3_key: photo.s3_key,
        });
      }

      if (photoBody.filter((photo) => photo.checkMain).length > 1) {
        photoBody.forEach((photo, key) => {
          photo.checkMain =
            key === photoBody.length - 1 && photo.checkMain ? true : false;
        });
      }

      setMainPhotos(photoBody);
    }

    handlerMainPhotos();
  }, [
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    productBackup,
    setMainPhotos,
  ]);

  useEffect(() => {
    if (!productBackup?.unidade_compra) {
      setSupplierPurchaseUnit(null);
      return;
    }

    setSupplierPurchaseUnit(
      listUnits.find((opt) => opt.un === productBackup.unidade_compra) || null
    );
  }, [productBackup, listUnits, setSupplierPurchaseUnit]);

  useEffect(() => {
    if (!productBackup?.idgrupoestoque) return;

    setMainGroup(
      listGroups.find(
        (opt) => parseInt(opt.id) === parseInt(productBackup.idgrupoestoque)
      ) || null
    );
  }, [productBackup, listGroups, setMainGroup]);

  useEffect(() => {
    setMainSubgroup(null);
    setListSubgroups(
      (mainGroup?.subgrupos || [])
        .filter((el) => el.ativo === 1)
        .sort((a, b) => a.descricao.localeCompare(b.descricao))
    );
  }, [mainGroup, setMainSubgroup, setListSubgroups]);

  useEffect(() => {
    if (!productBackup?.idsubgrupo || !listSubgroups.length) return;

    setMainSubgroup(
      listSubgroups.find(
        (opt) => parseInt(opt.id) === parseInt(productBackup.idsubgrupo)
      ) || null
    );
  }, [productBackup, listSubgroups, setMainSubgroup]);

  useEffect(() => {
    if (!productBackup?.unidade_venda) {
      setMainSalesUnit(null);
      return;
    }

    setMainSalesUnit(
      listUnits.find((opt) => opt.un === productBackup.unidade_venda) || null
    );
  }, [productBackup, listUnits, setMainSalesUnit]);

  useEffect(() => {
    if (!productBackup?.unidade_entrega) {
      setMainDeliveryUnit(null);
      return;
    }

    setMainDeliveryUnit(
      listUnits.find((opt) => opt.un === productBackup.unidade_entrega) || null
    );
  }, [productBackup, listUnits, setMainDeliveryUnit]);

  useEffect(() => {
    if (!productBackup?.idfornecedor) {
      setSupplier(
        listSupplier.find((opt) => opt.id === 1) || listSupplier[0] || null
      );
      return;
    }

    setSupplier(
      listSupplier.find((opt) => {
        return parseInt(opt.id) === parseInt(productBackup.idfornecedor);
      }) ||
        listSupplier[0] ||
        null
    );
  }, [productBackup, listSupplier, setSupplier]);

  useEffect(() => {
    setMainSubgroup(null);
    setListSubgroups(
      (mainGroup?.subgrupos || [])
        .filter((el) => el.ativo === 1)
        .sort((a, b) => a.descricao.localeCompare(b.descricao))
    );
  }, [mainGroup, setListSubgroups, setMainSubgroup]);

  useEffect(() => {
    if (queryParams?.datanf) {
      let dataNF = Buffer.from(queryParams.datanf, "base64").toString();
      dataNF = JSON.parse(dataNF);
      setMainDescription(dataNF["descricao"] || null);
      if (dataNF["descricao"]?.length > 30) {
        setMainResume(dataNF["descricao"].substring(0, 30) || null);
      } else {
        setMainResume(dataNF["descricao"] || null);
      }
      setMainNcm(dataNF["ncm"] ? { ncm: dataNF["ncm"] } : null);
      setMainStockUnit(
        listUnits.find((opt) => opt.un === dataNF["unidade"]) || null
      );
      setMainSalesUnit(
        listUnits.find((opt) => opt.un === dataNF["unidade"]) || null
      );
      setMainDeliveryUnit(
        listUnits.find((opt) => opt.un === dataNF["unidade"]) || null
      );
      setSupplier(
        listSupplier.find((opt) => {
          return parseInt(opt.id) === parseInt(dataNF["idfornecedor"]);
        }) ||
          listSupplier[0] ||
          null
      );
      setSupplierPurchaseUnit(
        listUnits.find((opt) => opt.un === dataNF["unidade"]) || null
      );
      setSupplierRef(dataNF["refforn"] || null);
    }
  }, [
    queryParams,
    setMainDescription,
    listUnits,
    setMainDeliveryUnit,
    setMainNcm,
    setMainSalesUnit,
    setMainStockUnit,
    listSupplier,
    setSupplier,
    setSupplierPurchaseUnit,
    setSupplierRef,
    setMainResume,
    clearAll,
    location,
  ]);

  const getConditions = useCallback(
    () => ({
      showCondition: {
        tabelaPrecos: queryParams.paramutilizatabelaprecos === "SIM",
        fornecedores: queryParams.guia_produtos_fornecedores === "1",
        fichaTecnica: queryParams.guia_produtos_fichatecnica === "1",
        relacionados: queryParams.guia_produtos_relacionados === "1",
        integracao: queryParams.guia_produtos_integracao === "1",
      },
    }),
    [
      queryParams.guia_produtos_fichatecnica,
      queryParams.guia_produtos_fornecedores,
      queryParams.guia_produtos_integracao,
      queryParams.guia_produtos_relacionados,
      queryParams.paramutilizatabelaprecos,
    ]
  );

  const { showCondition } = getConditions();

  return (
    <>
      <HeaderModule title="CADASTRO DE PRODUTOS" />

      <Loading open={loading} />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={2}>
          <AccordionProdutoPrincipal />
          <AccordionProdutoLocalEstoque />
          {showCondition.tabelaPrecos && <AccordionProdutoTabelaPreco />}
          {showCondition.fornecedores && <AccordionProdutoFornecedor />}
          {showCondition.fichaTecnica && (
            <AccordionProdutoFichaTecnicaComercial />
          )}
          {showCondition.relacionados && <AccordionProdutoRelacionado />}
          {showCondition.integracao && <AccordionProdutoIntegraccao />}
        </Grid>

        <Grid
          item
          container
          justifyContent="flex-end"
          style={{ marginTop: 20, marginBottom: 20 }}
          spacing={1}
        >
          <Grid item>
            <Btn label="Voltar" bgcolor="tertiary" onClick={handleBackSubmit} />
          </Grid>
          <Grid item>
            <Btn label="Salvar" onClick={() => handleSubmit(false)} />
          </Grid>
          <Grid item>
            <Btn label="Salvar e Novo" onClick={() => handleSubmit(true)} />
          </Grid>
        </Grid>
      </PainelContainer>
    </>
  );
};

const ProdutoCadastro = ({ ...props }) => (
  <ProdutoContextProvider>
    <View {...props} />
  </ProdutoContextProvider>
);

export default ProdutoCadastro;
